import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { Icon, Tooltip, RawHtml } from 'platfi-ui-components';

import { bemClassName } from 'utils/BEMHelper';
import styles from './FundingMatchCardRow.scss';

const propertyToValueConfig = {
  facility: (key) =>
    ({
      DISCOUNTING: 'Discounting',
      FACTORING: 'Factoring',
    }[key]),
  productOption: (key) =>
    ({
      HIRE_PURCHASE: 'Hire Purchase',
      FINANCE_LEASE: 'Finance Lease',
    }[key]),
};

const mapPropertyToValue = ({ propertyName, value, config }) => {
  const enumValueMapper = propertyToValueConfig[propertyName];

  if (enumValueMapper) {
    return enumValueMapper(value);
  }

  return config?.format ? config.format(value) : value;
};

const descriptionContent = ({ value }) => {
  if (!value) {
    return null;
  }

  return (
    <div
      styleName={bemClassName('m-funding-match-card-row__value', { small: true, bounded: true })}
    >
      <Tooltip
        bottom
        smallWidth
        styleName={bemClassName('m-funding-match-card-row__tooltip', { bounded: true })}
        tooltipContent={value}
      >
        <Icon icon="round_info" className="a-svg-small" />
        &nbsp;READ
      </Tooltip>
    </div>
  );
};

const defaultContent = ({ value, config, small, propertyName }) => {
  if (value === undefined || value === null) {
    return null;
  }

  return (
    <div styleName={bemClassName('m-funding-match-card-row__value', { small })}>
      {mapPropertyToValue({ propertyName, config, value })}
    </div>
  );
};

const DefaultContent = CSSModules(defaultContent, styles, { allowMultiple: true });
const DescriptionContent = CSSModules(descriptionContent, styles, { allowMultiple: true });

const FundingMatchCardRow = ({ value, small, config, propertyName, isTooltipHidden }) => (
  <>
    {propertyName === 'description' ? (
      <DescriptionContent value={value} />
    ) : (
      <DefaultContent value={value} config={config} small={small} propertyName={propertyName} />
    )}

    <div styleName="m-funding-match-card-row__label-container" className="u-flex-align-center">
      <div styleName="m-funding-match-card-row__label">{config?.title}</div>
      {config?.tooltip && !isTooltipHidden && (
        <Tooltip
          bottom
          smallWidth
          styleName="m-funding-match-card-row__tooltip"
          tooltipContent={<RawHtml>{config.tooltip}</RawHtml>}
        >
          <Icon icon="round_info" className="a-svg-small" />
        </Tooltip>
      )}
    </div>
  </>
);

FundingMatchCardRow.propTypes = {
  small: PropTypes.bool,
  value: PropTypes.string,
  config: PropTypes.object,
  isTooltipHidden: PropTypes.bool,
  propertyName: PropTypes.string,
};

descriptionContent.propTypes = {
  value: PropTypes.string,
};

defaultContent.propTypes = {
  small: PropTypes.bool,
  value: PropTypes.string,
  config: PropTypes.object,
  propertyName: PropTypes.string,
};

export default CSSModules(FundingMatchCardRow, styles, { allowMultiple: true });
